import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "./SearchResults.css";
import Item from "../Item/Item";
import SearchSkeleton from "../../Skeletons/Search-Skeleton";

const SearchResults = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const query = queryParams.get("query"); // Get query from URL params

  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Only fetch data if query exists
    if (query) {
      const fetchResults = async () => {
        setIsLoading(true);
        setError(null);
        try {
          const response = await axios.get(
            `https://kraafty-backend.onrender.com/api/search?query=${query}`
          );
          setResults(response.data.data || []);
        } catch (err) {
          console.error("Error fetching search results:", err);
          setError("Unable to fetch search results. Please try again later.");
        } finally {
          setIsLoading(false);
        }
      };

      fetchResults();
    }
  }, [query]); // Re-fetch when query changes

  return (
    <div>
      {!isLoading && !error && results.length > 0 && (
        <div className=" mt-2 sm:mt-10 text-center text-sm sm:text-2xl">
          Search Results for "{query}"
        </div>
      )}
      {isLoading && <SearchSkeleton />}
      {error && <p className="error-message">{error}</p>}
      {!isLoading && !error && results.length > 0 ? (
        <div className="shopcategory-products">
          {results.map((item) => (
            <Item
              key={item.id}
              id={item.id}
              name={item.product_name}
              image={item.main_image}
              new_price={item.offer_price}
              old_price={item.mrp}
              rating={item.rating}
            />
          ))}
        </div>
      ) : (
        !isLoading && (
          <div className="text-center w-full mt-10p-5 sm:p-20">
            <p className="text-lg text-gray-500">
              😕 No results found. Try refining your search.
            </p>
          </div>
        )
      )}
    </div>
  );
};

export default SearchResults;
